export default __webpack_public_path__ + "static/media/icon_ligthing.efce6526.svg";